'use strict';

(function() {
	angular.module('onboarding.common.settings')
		.directive('cobBrokerMessageSettings', cobBrokerMessageSettings);

	cobBrokerMessageSettings.$inject = [];

	function cobBrokerMessageSettings() {

		return {
			restrict: 'E',
			scope: {
				defaultMessageTitle: '=',
				defaultMessage: '=',
				defaultMessageDisabled: '=',
				toggleTitle: '=',
				customMessageTitle: '=',
				customMessage: '=',
				customMessageDisabled: '='
			},
			templateUrl: '/app/common/settings/broker/cobBrokerMessageSettings.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction() {}
})();
